import { NextPage } from 'next';

import { withSSRGuest } from '~/shared/utils/withSSRGuest';
import { ForgotPassword } from '~/modules/auth/pages/ForgotPassword';

export const getServerSideProps = withSSRGuest(async () => {
  return {
    props: {},
  };
});

const ForgotPasswordPage: NextPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
